import React from "react";
import styles from "./Footer.module.scss";
import visaSmall from "../../assets/images/visa-sm.png";
import maestroSmall from "../../assets/images/maestro-sm.png";
import paypalSmall from "../../assets/images/paypal-sm.png";
import americanExpressSmall from "../../assets/images/american-express-sm.png";
import FacebookIcon from "components/svgs/FacebookIcon";
import InstagramIcon from "components/svgs/InstagramIcon";
import TiktokIcon from "components/svgs/TiktokIcon";
import YoutubeIcon from "components/svgs/YoutubeIcon";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer>
      <div className={styles.footer_top}>
        <div className={styles.gridItem}>
          <div className={styles.navContainer}>
            <div className={styles.title}>About Us</div>
            <ul>
              <li>Who We Are</li>
              <li>Founder's Message</li>
              <li>Mission and Goals</li>
              <li>Our Team</li>
              <li>Feedbacks</li>
              <li>Contact Information</li>
            </ul>
          </div>
          <div className={styles.logo}>PAAH</div>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.navContainer}>
            <div className={styles.title}>Main Categories</div>
            <ul>
              <li
                onClick={() => {
                  navigate("/painters");
                }}
              >
                Artists
              </li>
              <li
                onClick={() => {
                  navigate("/paintings");
                }}
              >
                Paintings
              </li>
              <li>Sculptures</li>
              <li>Events</li>
              <li
                onClick={() => {
                  navigate("/galleries");
                }}
              >
                Galleries
              </li>
              <li>Museums</li>
              <li
                onClick={() => {
                  navigate("/pan-armenian-arthub");
                }}
              >
                PAAH
              </li>
              <li
                onClick={() => {
                  navigate("/guide");
                }}
              >
                Guide
              </li>
              <li className={styles.disabled}>Community</li>
            </ul>
          </div>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.navContainer}>
            <div className={styles.title}>Partnership</div>
            <ul>
              <li>Advertising Partnership</li>
              <li>Event Partnership</li>
              <li>Announcements</li>
              <li>For Galleries</li>
              <li>For Museums</li>
            </ul>
          </div>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.navContainer}>
            <div className={styles.title}>For Collectors</div>
            <ul>
              <li>Who We Represent</li>
              <li>How to Register</li>
              <li>How to Choose an Artwork</li>
              <li>How to Order an Artwork</li>
              <li>Additional Options for Loyal Clients</li>
            </ul>
          </div>
          <div className={styles.forArtistsItem}>
            <div className={styles.title}>For Artists</div>
            <ul>
              <li>Who We Accept</li>
              <li>How to Join</li>
              <li>How to Collaborate</li>
            </ul>
          </div>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.navContainer}>
            <div className={styles.title}>Important Information</div>
            <ul>
              <li>Legal Notices</li>
              <li>Terms and Conditions</li>
              <li>Privacy Policy</li>
              <li>Logistics</li>
            </ul>
          </div>
          <div className={styles.paymentMethodsItem}>
            <div className={styles.paymentMethodsTitle}>Payment Methods</div>
            <div className={styles.paymentCards}>
              <img src={visaSmall} alt="Visa" />
              <img src={maestroSmall} alt="Maestro" />
              <img src={paypalSmall} alt="Paypal" />
              <img src={americanExpressSmall} alt="American Express" />
            </div>
            <ul>
              <li>Payment Security</li>
              <li>Return Policy</li>
            </ul>
          </div>
        </div>
        <div className={`${styles.gridItem} ${styles.hideOnDesktop}`}>
          <div className={styles.navbarContainer}>
            <div className={styles.title}>For Artists</div>
            <ul>
              <li>Who We Accept</li>
              <li>How to Join</li>
              <li>How to Collaborate</li>
            </ul>
          </div>
        </div>
      </div>
      <div className={styles.paymentAndLogo}>
        <div className={styles.paymentMethodsItem}>
          <div className={styles.paymentMethodsTitle}>Payment Methods</div>
          <div className={styles.paymentCards}>
            <img src={visaSmall} alt="Visa" />
            <img src={maestroSmall} alt="Maestro" />
            <img src={paypalSmall} alt="Paypal" />
            <img src={americanExpressSmall} alt="American Express" />
          </div>
          <ul>
            <li>Payment Security</li>
            <li>Return Policy</li>
          </ul>
        </div>
        <div className={styles.logo}>PAAH</div>
      </div>
      <div className={styles.divider} />
      <div className={styles.footer_bottom}>
        <div className={styles.copyright}>
          <span>© {new Date().getFullYear()}</span>
          <span>PAAH</span>
          <span>All Rights Reserved</span>
        </div>
        <div className={styles.socialLinks}>
          <span className={styles.joinUsTitle}>Join Us</span>
          <a href="https://facebook.com" target="_blank" rel="noreferrer">
            <FacebookIcon />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer">
            <InstagramIcon />
          </a>
          <a href="https://tiktok.com" target="_blank" rel="noreferrer">
            <TiktokIcon />
          </a>
          <a href="https://youtube.com" target="_blank" rel="noreferrer">
            <YoutubeIcon />
          </a>
        </div>
        <div className={styles.faq}>Frequently Asked Questions (FAQ)</div>
      </div>
    </footer>
  );
};

export default Footer;
